/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statswindow24h1Inputs */

const en_statswindow24h1 = /** @type {(inputs: Statswindow24h1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last 24 h`)
};

const de_statswindow24h1 = /** @type {(inputs: Statswindow24h1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte 24 Std.`)
};

/**
* | output |
* | --- |
* | "Last 24 h" |
*
* @param {Statswindow24h1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statswindow24h1 = /** @type {((inputs?: Statswindow24h1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statswindow24h1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statswindow24h1(inputs)
	return de_statswindow24h1(inputs)
});
export { statswindow24h1 as "statsWindow24h" }